module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main-body"
  }, [_c('el-row', {
    attrs: {
      "gutter": 10
    }
  }, [_c('el-col', {
    attrs: {
      "xs": 24
    }
  }, [_c('h1', {
    staticClass: "pageTitle",
    class: {
      'pageTitle--dark': !_vm.isInOwnRoute
    }
  }, [_c('i', {
    staticClass: "fa fa-cubes",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("  " + _vm._s(_vm.$t('static.productPackagings.create.title')))])])], 1), _vm._v(" "), _c('div', {
    class: {
      'whiteWrapper': _vm.isInOwnRoute
    }
  }, [(_vm.isInOwnRoute) ? _c('el-tabs', {
    attrs: {
      "value": "1"
    }
  }, [_c('el-tab-pane', {
    attrs: {
      "label": _vm.$t('static.productPackagings.formTabs.packagingInformation'),
      "name": "1"
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('v-form', {
    attrs: {
      "form": _vm.form,
      "translation": "form.productPackagings",
      "hasLabel": true
    }
  })], 1)], 1)], 1) : _c('v-form', {
    attrs: {
      "form": _vm.form,
      "translation": "form.productPackagings",
      "hasLabel": true
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "full-w flex justify-center buttons_under_main_body"
  }, [(_vm.isInOwnRoute) ? _c('router-link', {
    attrs: {
      "to": {
        name: 'productPackagings.index'
      }
    }
  }, [_c('el-button', {
    staticClass: "dark"
  }, [_vm._v(_vm._s(_vm.$t('button.cancel').toUpperCase()))])], 1) : _vm._e(), _vm._v(" "), _c('el-button', {
    class: {
      'outline': _vm.isInOwnRoute
    },
    attrs: {
      "loading": _vm.form.loading
    },
    on: {
      "click": _vm.store
    }
  }, [_vm._v(_vm._s(_vm.$t('button.save').toUpperCase()))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-70c0ebac","hasScoped":false}!./src/app/pages/withNavigation/productPackagings/create/create.html
// module id = 3062
// module chunks = 1